import { useQuery } from "react-query";

import { QUERY_STRINGS } from "../../constants";
import upcomingCVsService from "../../services/upcomingCVs";
import { SnackbarState, useSnackbar } from "../../store/useSnackbar";
import { ErrorContent } from "../../types/default";

const addSnackbarSelector = (state: SnackbarState) => state.addSnackbar;

export const useUpcomingCVs = (page: number, perPage: number, handleChangePage?: (newPage: number) => void) => {
  const addSnackbar = useSnackbar(addSnackbarSelector);

  const { data: upcomingCVsData, isLoading } = useQuery(
    [QUERY_STRINGS.GET_UPCOMING_CVS, page, perPage],
    () => upcomingCVsService.getUpcomingCVs(page, perPage),
    {
      keepPreviousData: true,
      onError: (error: ErrorContent) => addSnackbar({ text: error.message }),
      onSuccess: data =>
        !data.data.length && data.totalElements && page && handleChangePage && handleChangePage(page - 1),
    }
  );

  return { upcomingCVsData, isLoading };
};
